export const noop = terminal => terminal;